// Design tokens for the Vivamos el Campo brand.
//
// Earthy / natural palette derived from the platform logo (leaf-green hill,
// white farmhouse, golden sun). These tokens are the stable contract shared by
// all new (non-template) components, and later by the modern MUI theme — so the
// migration off `material-kit-pro-react` only ever has to re-point styling at
// these values, never re-pick colors.

const palette = {
  primary: "#3F7D34", // campo green
  primaryDark: "#2F5E27",
  secondary: "#B85C38", // warm earth / terracotta
  accent: "#E8A33D", // golden sun
  background: "#FAF6EF", // cream
  surface: "#FFFFFF",
  textPrimary: "#2E2A26", // dark soil
  textSecondary: "#6B5E52",
  success: "#43A047",
  error: "#C62828"
};

const typography = {
  // Display font for headings (already loaded by the app's global stylesheet).
  fontFamilyDisplay: `"Roboto Slab", "Times New Roman", serif`,
  fontFamilyBase: `"Roboto", "Helvetica", "Arial", sans-serif`
};

const shape = {
  borderRadius: "16px"
};

const shadows = {
  card: "0 8px 24px rgba(46, 42, 38, 0.12)",
  cardHover: "0 14px 32px rgba(46, 42, 38, 0.18)"
};

const brand = { palette, typography, shape, shadows };

export default brand;
export { palette, typography, shape, shadows };



// WEBPACK FOOTER //
// ./src/theme/brand.js